import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';
import { AppBarTitleService, AppBarActionsService } from 'common';
import { AuditTrailData } from '../audit-trail.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-audit-trail-detail',
    templateUrl: './audit-trail-detail.component.html',
    styleUrls: ['./audit-trail-detail.component.scss'],
    standalone: false
})
export class AuditTrailDetailComponent implements OnInit {

  downloadJsonHref: any;

  constructor(private route: ActivatedRoute,
    private appBarTitleService: AppBarTitleService,
    private appBarActionsService: AppBarActionsService,
    private sanitizer: DomSanitizer
  ) {
    this.appBarActionsService.actions = [];

    this.route.data.pipe(untilDestroyed(this))
      .subscribe(it => {
        this.data = it.auditTrail;
        this.generateDownloadJsonUri();
        this.appBarActionsService.actions.push({
          id: 'json',
          label: 'Download',
          disabled: false,
          buttonType: 'download',
          name: `${this.titleInit()}.json`,
          link: this.downloadJsonHref,
          icon: 'get_app'
        });
      });
  }

  data: AuditTrailData;

  ngOnInit() {
    this.appBarTitleService.title = this.titleInit();
  }

  titleInit(): string {
    // eslint-disable-next-line max-len
    return `${_.startCase(this.data.event)}, ${formatDate(this.data.date, 'medium', 'en_US')}, ${this.data.initiator.fullName}`;
  }

  getJson(): JSON {
    return JSON.parse(this.data.json);
  }

  generateDownloadJsonUri(): void {
    const jsonData = JSON.stringify(this.getJson());
    const uri = this.sanitizer.bypassSecurityTrustUrl("data:text/json;charset=UTF-8," + encodeURIComponent(jsonData));
    this.downloadJsonHref = uri;
  }

}
